// extracted by mini-css-extract-plugin
export var avatar = "_m5-3";
export var avatarContainer = "_m5-2";
export var avatarSpacer = "_m5-5";
export var avatarSpacerContainer = "_m5-4";
export var avatarStackContainer = "_m5-1";
export var bubble = "_m5-0";
export var remainderBubble = "_m5-6";